(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var mobileMenu = document.querySelector('#mobile_menu');
    var openMenuLink = document.querySelector('#collection-menu-link');

    if (mobileMenu && openMenuLink) {
      openMenuLink.addEventListener('click', function(e) {
        e.preventDefault();
        if($('body').hasClass('no-scroll')){
          $('body, html').removeClass('no-scroll');
          $('.collection-menu').removeAttr('style');
          $('#mobile_menu').removeClass('open');
        } else {
          $('body, html').addClass('no-scroll');
          $('.collection-menu').attr('style', 'position: fixed !important; width: 100%; overflow-y: scroll; height: 100%; padding-bottom: 95px !important;');
          $('#mobile_menu').addClass('open');

        }
        $(mobileMenu).slideToggle();
        $(openMenuLink).find('span').toggleClass('active');
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
